import { NavPanes } from "./NavPanes"
import { Pane } from "./Pane"

NavPanes.Pane = Pane;

export {
    NavPanes
}
